/**
 * Codex Design System — Breakpoints
 *
 * Full 7-point scale from Figma Foundations §10.
 * MUI requires xs=0 — sxs and xxl are additive custom breakpoints.
 *
 * Usage in components:
 *   sx={{ display: { xs: 'none', md: 'flex' } }}
 *   theme.breakpoints.up('lg')
 *   theme.breakpoints.between('sm', 'xl')
 *
 * Figma frame widths:
 *   sxs → 320px  xs → 390px  sm → 640px  md → 768px
 *   lg → 1024px  xl → 1280px  2xl → 1440px
 */

import type { ThemeOptions } from '@mui/material/styles';

export const breakpoints: ThemeOptions['breakpoints'] = {
  values: {
    xs: 0, // MUI internal minimum (required)
    sm: 640, // large phones / small tablets
    md: 768, // tablets (portrait)
    lg: 1024, // tablets (landscape) / small laptops
    xl: 1280, // standard desktops
    // Custom Codex breakpoints:
    sxs: 300, // very small phones (Galaxy Fold, iPhone SE)
    xxl: 1536, // large desktops / ultrawide ("2xl" in Figma)
  },
};
